// extracted by mini-css-extract-plugin
module.exports = {"areaHeading":"PlayerWindow_areaHeading__4kt-o","fillHeight":"PlayerWindow_fillHeight__3PhEC"};